module.exports = __webpack_public_path__ + "static/media/kids_16.c9fddd02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_16.jpg
// module id = 5872
// module chunks = 0